import {
  CustomFieldEntity,
  ExpenseReportAnalyticGroup,
  StipendExpenseAnalyticGroup,
} from "@common/utils/graphql";

export const NAME_FOR_EXPENSE_REPORT_ANALYTIC_GROUP: Record<
  ExpenseReportAnalyticGroup,
  string
> = {
  [ExpenseReportAnalyticGroup.Category]: "Category",
  [ExpenseReportAnalyticGroup.Department]: "Department",
  [ExpenseReportAnalyticGroup.Employee]: "Employee",
  [ExpenseReportAnalyticGroup.ExpenseStatus]: "Expense Status",
  [ExpenseReportAnalyticGroup.Merchant]: "Merchant",
  [ExpenseReportAnalyticGroup.PaymentMethod]: "Payment Method",
  [ExpenseReportAnalyticGroup.PolicyStatus]: "Policy Status",
  [ExpenseReportAnalyticGroup.ReportStatus]: "Report Status",
  [ExpenseReportAnalyticGroup.Reviewer]: "Reviewer",
  [ExpenseReportAnalyticGroup.CustomField]: "Custom Field",
  [ExpenseReportAnalyticGroup.Manager]: "Manager",
};

export const getNameForExpenseReportAnalyticGroup = (
  groupBy: ExpenseReportAnalyticGroup,
  selectedCustomField?: CustomFieldEntity,
) => {
  if (groupBy === ExpenseReportAnalyticGroup.CustomField) {
    return selectedCustomField?.name ?? "Custom Field";
  }
  return NAME_FOR_EXPENSE_REPORT_ANALYTIC_GROUP[groupBy];
};

export const NAME_FOR_STIPEND_EXPENSE_ANALYTIC_GROUP: Record<
  StipendExpenseAnalyticGroup,
  string
> = {
  [StipendExpenseAnalyticGroup.Category]: "Category",
  [StipendExpenseAnalyticGroup.Department]: "Department",
  [StipendExpenseAnalyticGroup.Employee]: "Employee",
  [StipendExpenseAnalyticGroup.StipendExpenseStatus]: "Expense Status",
  [StipendExpenseAnalyticGroup.Merchant]: "Merchant",
  [StipendExpenseAnalyticGroup.PaymentMethod]: "Payment Method",
  [StipendExpenseAnalyticGroup.PolicyStatus]: "Policy Status",
  [StipendExpenseAnalyticGroup.Reviewer]: "Reviewer",
  [StipendExpenseAnalyticGroup.StipendRule]: "Stipend",
  [StipendExpenseAnalyticGroup.Manager]: "Manager",
};

export const getNameForStipendExpenseAnalyticGroup = (
  groupBy: StipendExpenseAnalyticGroup,
) => NAME_FOR_STIPEND_EXPENSE_ANALYTIC_GROUP[groupBy];
